import { ServiceResponseErrorCode, ServiceResponseResult } from "../enums";
import { ValidationError } from "../models";

class ServiceResponseNoContent {

    public content;

    public result: ServiceResponseResult;

    public wasSuccessful: boolean;

    public wasUnsuccessful: boolean;

    public errorCode: ServiceResponseErrorCode;

    public errorMessage: string;

    public validationErrors: ValidationError[];

    constructor()
    constructor(errorCode: ServiceResponseErrorCode, errorMessage: string)
    constructor(errorCode: ServiceResponseErrorCode, errorMessage: string, validationErrors: ValidationError[])
    constructor(errorCode: ServiceResponseErrorCode = ServiceResponseErrorCode.NoError, errorMessage: string = "", validationErrors: ValidationError[] = []) {

        if (errorCode === ServiceResponseErrorCode.NoError)
        {
            this.result = ServiceResponseResult.Successful;
            this.errorCode = ServiceResponseErrorCode.NoError;
            this.wasSuccessful = true;
            this.wasUnsuccessful = false;
        }
        else {
            this.result = ServiceResponseResult.Failed;
            this.errorCode = errorCode;
            this.errorMessage = errorMessage;
            this.validationErrors = validationErrors;
            this.wasSuccessful = false;
            this.wasUnsuccessful = true;
        }
    }
};

class ServiceResponse<T> extends ServiceResponseNoContent {
	
    constructor(content: T)
    constructor(errorCode: ServiceResponseErrorCode, errorMessage: string)
    constructor(errorCode: ServiceResponseErrorCode, errorMessage: string, validationErrors: ValidationError[])
    constructor(errorCodeOrContent: T | ServiceResponseErrorCode, errorMessage: string = "", validationErrors: ValidationError[] = []) {

        if (typeof errorCodeOrContent === "number" && errorMessage.length > 0)
        {
            super(errorCodeOrContent as ServiceResponseErrorCode, errorMessage, validationErrors);
        }
        else {
            super();
            this.content = errorCodeOrContent as T;
        }
    }
};

export { ServiceResponseNoContent, ServiceResponse };